(function () {
  let cards = [];
  let observers = [];

  const updateMask = (card, content, mask) => {
    if (!card || !content || !mask) return;

    if (window.innerWidth < 750) {
      mask.style.removeProperty("--mask-hole-x");
      mask.style.removeProperty("--mask-hole-y");
      mask.style.removeProperty("--mask-hole-radius");
      mask.classList.remove("media-card__mask--initialized");
      return;
    }

    const children = content.children;
    const cardRect = card.getBoundingClientRect();
    const contentRect = content.getBoundingClientRect();

    const holeX = cardRect.width / 2;
    const widthPx = contentRect.width - 44;
    const radius = widthPx / 2;
    let offsetY;

    if (!children.length) {
      offsetY = cardRect.height / 2;
    } else if (
      children.length === 1 &&
      children[0].classList.contains("block-button")
    ) {
      const btnRect = children[0].getBoundingClientRect();
      offsetY = btnRect.top - cardRect.top - 24 - radius;
    } else {
      const firstRect = children[0].getBoundingClientRect();
      offsetY = firstRect.bottom - cardRect.top + 24 + radius;
    }

    mask.style.setProperty("--mask-hole-x", `${holeX}px`);
    mask.style.setProperty("--mask-hole-y", `${offsetY}px`);
    mask.style.setProperty("--mask-hole-radius", `${radius}px`);
    mask.dataset.initialRadius = radius;

    if (!mask.classList.contains("media-card__mask--initialized")) {
      mask.classList.add("media-card__mask--initialized");
    }
  };

  const expandMask = (card, mask) => {
    if (!card || !mask) return;

    const rect = card.getBoundingClientRect();

    const holeX = parseFloat(mask.style.getPropertyValue("--mask-hole-x"));
    const holeY = parseFloat(mask.style.getPropertyValue("--mask-hole-y"));

    if (isNaN(holeX) || isNaN(holeY)) return;

    const distances = [
      Math.hypot(holeX - 0, holeY - 0),
      Math.hypot(holeX - rect.width, holeY - 0),
      Math.hypot(holeX - 0, holeY - rect.height),
      Math.hypot(holeX - rect.width, holeY - rect.height),
    ];

    const maxRadius = Math.max(...distances) + 50;

    mask.style.setProperty("--mask-hole-radius", `${maxRadius}px`);
  };

  const resetMask = (mask, initialRadius) => {
    if (!mask) return;

    mask.style.setProperty("--mask-hole-radius", `${initialRadius}px`);
  };

  const initMediaCardMask = (card) => {
    if (!card) return;

    const content = card.querySelector(".media-card__content");
    const mask = card.querySelector(".media-card__mask");
    if (!content || !mask) return;

    const ro = new ResizeObserver(() => updateMask(card, content, mask));
    ro.observe(content);

    observers.push(ro);
    cards.push({ card, content, mask });

    updateMask(card, content, mask);
  };

  const initSection = (section) => {
    if (!section || !section.classList.contains("media-cards-section")) {
      return;
    }

    observers.forEach((o) => o.disconnect());
    observers = [];
    cards = [];

    section
      .querySelectorAll(".media-card.media-card--layout-vertical")
      .forEach((card) => initMediaCardMask(card));
  };

  document.addEventListener(
    "mouseenter",
    (e) => {
      const entry = cards.find((x) => x.card === e.target);
      if (!entry) return;

      const { card, mask } = entry;
      if (window.innerWidth < 750) return;

      expandMask(card, mask);
    },
    true
  );

  document.addEventListener(
    "mouseleave",
    (e) => {
      const entry = cards.find((x) => x.card === e.target);
      if (!entry) return;

      if (window.innerWidth < 750) return;

      const { mask } = entry;

      const initialRadius = mask.dataset.initialRadius;

      if (initialRadius) resetMask(mask, initialRadius);
    },
    true
  );

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });
})();
